import React from 'react';
import OurAchievement from '../carousel/our-archievements-carousel'
import HappyClients from '../carousel/happy-clients'
import Stats from '../carousel/stats-overview'
import Team from '../carousel/team'

function Home(){
    return <>

    <div className="SliderBox">
        <div className="container">
            <div className="Boxes BoxesF">
                <div className="LeftWrap Box-Content">
                    <img className="TopImg" src={require('../../images/leftimg.webp')} alt='Left'/>
                    <div className='ContentWrap'>
                    <div className='HeadingBox'>
                        <img src={require('../../images/icon1.webp')} alt='Design & Art'/>
                        <h3>Design & Art</h3>
                    </div>
                    <div className='TextBox'>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </p>
                    </div>
                    </div>
                </div>
                <div className="MiddleWrap"><img className="TopImg" src={require('../../images/logo-center.webp')} alt='Center Logo'/></div>
                <div className="RightWrap Box-Content">
                <img className="TopImg" src={require('../../images/rightimg.webp')} alt='Programming'/>
                    <div className='ContentWrap'>
                    <div className='HeadingBox'>
                    <h3>Programming</h3>
                        <img src={require('../../images/icon2.webp')} alt='Programming Logo'/>
                        
                    </div>
                    <div className='TextBox'>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </p>
                    </div>
                    </div>
                </div>
            </div>

            <div className="Boxes BottomBoxes">
                <div className="RightWrap Box-Content">
                <img className="TopImg" src={require('../../images/bottomleft.webp')} alt='Advertisement'/>
                    <div className='ContentWrap'>
                    <div className='HeadingBox'>
                    <h3>Advertisement</h3>
                        <img src={require('../../images/icon3.webp')} alt='Advertisement Logo'/>
                        
                    </div>
                    <div className='TextBox'>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </p>
                    </div>
                    </div>
                </div>
                <div className="LeftWrap Box-Content">
                    <img className="TopImg" src={require('../../images/bottoright.webp')} alt='Koordinator'/>
                    <div className='ContentWrap'>
                    <div className='HeadingBox'>
                        <img src={require('../../images/icon4.webp')} alt='Koordinator Logo'/>
                        <h3>Koordinator</h3>
                    </div>
                    <div className='TextBox'>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </p>
                    </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    
    <div className='SecondWrap'>
        <div className='container'>
            <h1 className='MainHeading'>our Archievements</h1>
            <OurAchievement/>
            <h1 className='MainHeading'>our Archievements</h1>
        </div>

    </div>
    <div className='InfoBox'>
        
            <div className='ListBox'>
            <div className='color red'></div>
            <div className='container'>
            <div className='ContentBox'>
                <div className='ImgBox'>
                    <img src={require('../../images/super.webp')} alt='Super'/>
                </div>
                <div className='TextBox'>
                    <div className='TextWrap'>
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div className='ListBox'>
            <div className='color blue'></div>
            <div className='container'>
            <div className='ContentBox'>
                <div className='ImgBox'>
                    <img src={require('../../images/super-designer.webp')} alt='Super Designer'/>
                </div>
                <div className='TextBox'>
                    <div className='TextWrap'>
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div className='ListBox'>
            <div className='color green'></div>
            <div className='container'>
            <div className='ContentBox'>
                <div className='ImgBox'>
                    <img src={require('../../images/programmer.webp')} alt='Super programmer'/>
                </div>
                <div className='TextBox'>
                    <div className='TextWrap'>
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div className='ListBox'>
            <div className='color yellow'></div>
            <div className='container'>
            <div className='ContentBox'>
                <div className='ImgBox'>
                    <img src={require('../../images/super-werb.webp')} alt='super-werb'/>
                </div>
                <div className='TextBox'>
                    <div className='TextWrap'>
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
                </div>
                </div>
            </div>
            </div>
        </div>

    </div>
    <div className='HappyClients'>
        <div className='container'>
    <h1 className='MainHeading'>Happy Clients</h1>
    <HappyClients/>
    </div>
    </div>

    <div className='StatsOverview'>
    <div className='container'>
    <h1 className='MainHeading'>Stats Overview</h1>
    <Stats/>
    </div>
    </div>

    <div className='OurTeam'>
    <div className='container'>
    <h1 className='MainHeading'>our Team</h1>
    <Team/>
    </div>
    </div>
    </>
}
export default Home;